import React, { useState } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import { Form, Input, Button, Row, Col,Alert  } from 'antd';
import { LoadingOutlined, MailOutlined, KeyOutlined } from '@ant-design/icons';
import { useLocation, useHistory} from 'react-router-dom';
import { resetPassword } from "../../../Actions/api";

function ResetPassword() {
    const search = useLocation().search;
    const email = new URLSearchParams(search).get('email');
    const code = new URLSearchParams(search).get('code');
    const isFirstTimeLogin = new URLSearchParams(search).get('isFirstTimeLogin');
    const history = useHistory();
    const [form] = Form.useForm();

    const layout = {
        labelCol: {
            span: 12,
        },
        wrapperCol: {
            span: 24,
        },
    };

    const [loading, setLoading] = useState(false);
    const { message } = useSelector(state => state.message);
    const dispatch = useDispatch();

    const onFinish = (e) => {
        setLoading(true);
        dispatch(resetPassword(email, code , e.newPassword, e.confirmPassword))
        .then(() => {
            setLoading(false);
            form.resetFields();
            // history.push("/Login");
        }).then(
            setTimeout(() => { 
                history.push('/Login');
              }, 2000)
        )
        .catch(() => {
          setLoading(false);
        });
    }
    return (
        <div className="CP-container" justify="center">
            <div className="CP-title">{isFirstTimeLogin === "true" ? 'Change Password' : 'Reset Password'}</div>
            {isFirstTimeLogin === "true" && <center><small>To ensure you use a strong password, you are required to create a password before you login for the first time.</small></center>}
            {/* <div className="sub-signin-title">JUST ONE STEP AWAY FROM OUR AWESOME APIs</div> */}
            {message && 
            (
                <Row gutter={24}>
                    <Col xs={24} sm={24} md={24} lg={6} xl={6} justify="center"></Col>
                    <Col xs={24} sm={24} md={24} lg={12} xl={12} justify="center">
                    {message && (
                        <div>
                            {/* { message[0] == true ? <Alert message="Successful To Registration" type="success" closable/> : <Alert message={message[1].map((list) =><div>{list}</div>)} type="error" closable/> } */}
                            { message[0] === true ? <Alert message={message[1]} type="success"/> : <Alert message={message[1]!=null ? message[1] : message[2]} type="error"/> }
                        </div>
                    )}
                    </Col>
                </Row>
            )
            }
            <Form
                {...layout}
                layout="vertical"
                name="basic"
                onFinish={onFinish}
                className="CP_form"
                form={form}
                initialValues={{
                    "email": email
                }}
            >
                {isFirstTimeLogin === 'false' && 
                <Row gutter={24}>
                    <Col xs={24} sm={24} md={24} lg={6} xl={6} justify="center"></Col>
                    <Col xs={24} sm={24} md={24} lg={12} xl={12} justify="center">
                    <Form.Item
                        label={<label className="label_FP">Email</label>}
                        name="email"
                        rules={[
                            {
                                type: 'email',
                                message: 'The input is not valid E-mail!',
                            },
                            {
                                required: true,
                                message: 'Please input your email address!',
                            },
                        ]}
                    >
                        <Input addonBefore={<MailOutlined />} size="large" readOnly placeholder=""/>
                    </Form.Item>
                    </Col>
                </Row>}
                <Row gutter={24}>
                    <Col xs={24} sm={24} md={24} lg={6} xl={6} justify="center"></Col>
                    <Col xs={24} sm={24} md={24} lg={12} xl={12} justify="center">
                    <Form.Item
                        label={<label className="label_CP">New Password</label>}
                        name="newPassword"
                        rules={[
                            {
                                required: true,
                                message: 'Please input your new password!',
                            },
                            {   
                                min: 8, 
                                message: 'New Password must be minimum 8 characters.' 
                            },
                            {
                                pattern: "(?=.*[a-z])",
                                message: 'At least one lower case' 
                            },
                            {
                                pattern: "(?=.*[A-Z])",
                                message: 'At least one Upper case' 
                            },
                            {
                                pattern: "(?=.*[@$!%*#?&_-])",
                                message: 'At least one Special Character' 
                            },
                            {
                                pattern: "(?=.*[0-9])",
                                message: 'At least one Digital Number' 
                            }
                        ]}
                    >
                        <Input.Password addonBefore={<KeyOutlined />} size="large" placeholder=""/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col xs={24} sm={24} md={24} lg={6} xl={6} justify="center"></Col>
                    <Col xs={24} sm={24} md={24} lg={12} xl={12} justify="center">
                    <Form.Item
                        label={<label className="label_CP">Confirm Password</label>}
                        name="confirmPassword"
                        dependencies={['newPassword']}
                        rules={[
                            {
                              required: true,
                              message: 'Please confirm your password!',
                            },
                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                if (!value || getFieldValue('newPassword') === value) {
                                  return Promise.resolve();
                                }
                  
                                return Promise.reject(new Error('The two passwords that you entered do not match!'));
                              },
                            }),
                        ]}
                    >
                        <Input.Password addonBefore={<KeyOutlined />} size="large" placeholder=""/>
                    </Form.Item>
                    </Col>
                </Row>
                <br/>
                <Form.Item style={{textAlign:"center"}}>
                    <Button type="primary" htmlType="submit" size="large" className="button_CP">
                        {loading && (
                            <LoadingOutlined /> 
                        )}
                        Submit
                    </Button>
                </Form.Item>
            </Form>
        </div>
    );
}

export default ResetPassword;